import authConfig from '@/configs/auth';
import axiosInstance from '@/configs/axios';

const statusOf = (error: unknown): number | undefined => (error as { response?: { status?: number } })?.response?.status;

/**
 * Pergunta ao servidor se ele ainda reconhece a sessão: `/user/me` 2xx → `true`, 401 → `false`.
 * Qualquer outra falha (rede, 5xx) é repassada, porque não dá para afirmar nem uma coisa nem
 * outra — quem chama decide o que fazer com a dúvida.
 */
export async function hasServerSession(): Promise<boolean> {
  try {
    await axiosInstance.get(authConfig.meEndpoint);
    return true;
  } catch (error) {
    if (statusOf(error) === 401) return false;
    throw error;
  }
}

/**
 * Encerra a sessão no servidor e só resolve quando o servidor confirma que ela acabou.
 *
 * A prova de que saiu é o `/user/me` responder 401 — qualquer outra resposta, inclusive falha
 * de rede, é tratada como "não deu para confirmar".
 */
export async function endSession(): Promise<void> {
  try {
    await axiosInstance.post(authConfig.logoutEndpoint);
  } catch (error) {
    // 401/419 no logout significa que a sessão já não valia; quem decide é a verificação abaixo.
    if (statusOf(error) !== 401 && statusOf(error) !== 419) throw error;
  }

  if (await hasServerSession()) throw new Error('The server still recognises the session after logout');
}
